import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const ChangeFacility = () => {
  return (
    <div>
      <PageTitle title='Change Facility' role='Facility Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Facility Managers have the ability to change their current facility. This can be done by clicking the dropdown of the facility name in the top navigation menu. Once the facility has changed, the Facility Manager should be able to access information in that particular facility as if he or she were now a Risk Manager of that facility.' />
      <ParaImageDialog src='/tutorial_image/change-facility-1.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'Approve Events', link: '/approver/approve-events' },
          next: { name: 'Facility Management', link: '/organization-manager/facility-management' }
        }}
      />
    </div>
  );
};

export default ChangeFacility;
